var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toggleModal}},[_c('CIcon',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"name":"cil-pencil","placement":"top"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }